import React from 'react';
import { Field, ErrorMessage } from 'formik';

export const StepSix = () => {
  const options = [
    {
      value: 'B',
      label: 'Bullying',
    },
    {
      value: 'RR',
      label: 'Redundancy',
    },
    {
      value: 'W',
      label: 'Whistleblowing',
    },
    {
      value: 'S',
      label: 'Sickness',
    },
    {
      value: 'Sn',
      label: 'Suspension',
    },
    {
      value: 'Dy',
      label: 'Disciplinary',
    },
    {
      value: 'H',
      label: 'Unsafe workplace',
    },
    {
      value: 'P',
      label: 'Performance',
    },
    {
      value: 'TWE',
      label: 'Toxic work environment',
    },
    {
      value: 'EW',
      label: 'Excessive workload',
    },
    {
      value: 'M',
      label: 'Money owed',
    },
    {
      value: 'F',
      label: 'No contract',
    },
    {
      value: 'OBT',
      label: 'Other',
    },
  ];
  return (
    <div className="w-full max-w-md mx-auto p-6 bg-white shadow-md rounded-md step">
      {/* <h6 className="text-lg font-bold mb-6">Employment issues</h6> */}

      <div className="mb-6 form-radio2-main">
        <p>
          <strong>Employment issues *</strong>
          <span>Select all that apply</span>
        </p>
        <div className="space-y-2">
          {options?.map((ele, i) => {
            const id = `employment_issues_${i}`;
            return (
              <div key={id} className="flex items-center form-check2">
                <Field
                  type="checkbox"
                  id={id}
                  name="employment_issues"
                  value={ele?.value}
                  className="mr-2"
                />
                <label htmlFor={id}>{ele?.label}</label>
              </div>
            );
          })}
          <ErrorMessage name="employment_issues" component="div" className="required-text" />
        </div>
      </div>
    </div>
  );
};
